import apiHelper from "./apiHelper";
import axios from "axios";
import { create } from "apisauce";

// LOCAL
// export const rootUrl = "https://localhost:7145";

// PRODUCTION
export const rootUrl = "https://etahsilatapi.elogo.com.tr";

// TEST
// export const rootUrl = "https://etahsilatapi-test.elogo.com.tr";

export const commonRootUrl ="https://tahsilat.elogo.com.tr"
// const rootUrl =commonRootUrl+  "/etahsilatpaymentapi";


const api = create({
  baseURL: rootUrl,
})

type apiParams={
apiKey: string,
apiSecret: string
}
 
const commonNetwork = {

  get: async function (method: string, params: any, apiParams: apiParams) {
    const apiKey = apiParams?.apiKey;
    const apiSecret= apiParams?.apiSecret;
    const headerAuth = btoa(apiKey + ":" + apiSecret); 
     

    const response = await api.get(method, params, {
      headers:{
        Authorization: `basic ${headerAuth}` 
      }
    });
     
    if (response.ok) {
      return apiHelper.apiSuccess({ result: response });
    } else {
      return apiHelper.apiError({ errorMsg: response.data });
    } 
  },

  post: async function (method: string, params: any, apiParams: apiParams) { 

    const apiKey = apiParams?.apiKey;
    const apiSecret= apiParams?.apiSecret;
    const headerAuth = btoa(apiKey + ":" + apiSecret);

    const response = await api.post(method, params, {
      headers:{
        Authorization: `basic ${headerAuth}` ,
        "Content-Type": "application/json; charset=utf-8",
        "Accept": "application/json"
      }
    });

    if (response.ok) {
      return apiHelper.apiSuccess({
        result: response
      });
    } else {
      return apiHelper.apiError({ errorMsg: response.data });
    }
  
  },
  postFormData: async function (method, obj) {
    const apiUrl = process.env.REACT_APP_BASE_URL;
    const url = rootUrl + method;


    try {
      const response = await axios.post(url, obj, {
        headers: {
          Accept: "*/*",
          "Content-Type": "multipart/form-data"
        },
      });
      return apiHelper.apiSuccess({
        result: response
      });
    } catch (error) {

      return apiHelper.apiError({ errorMsg: error });
    }
  }, 
}

export default commonNetwork;